/**
 * Shared GlobalContext dropdownCache keys for SearchInputFieldWithDebounce.
 * Same BQ master (sites/items/…) must use one key across PO + SO fields.
 */
export const BQ_MASTER_CACHE_KEYS = {
	sites: "bq_master_sites",
	/** PO owner site label is Name (Short Name) - Code */
	sitesShort: "bq_master_sites_name_short",
	vendors: "bq_master_vendors",
	/** PO vendor shows SLNAME and carries vendor defaults — keep separate from any older vendor cache */
	vendorsShort: "bq_master_vendors_slname_v5",
	currencies: "bq_master_currencies",
	tradeGroups: "bq_master_trade_groups",
	agents: "bq_master_agents",
	transporters: "bq_master_transporters",
	merchandisers: "bq_master_merchandisers",
	channels: "bq_master_po_channels_v2",
	items: "bq_master_items",
	/** PO maps rate from INVITEM.COSTRATE — keep separate from SO (RATE) cache */
	itemsPo: "bq_master_items_po",
};

/** PO header / line column.key → GlobalContext cache key */
export const poMasterCacheKeyByColumn = {
	owner_site_code: BQ_MASTER_CACHE_KEYS.sitesShort,
	vendor_code: BQ_MASTER_CACHE_KEYS.vendorsShort,
	currency_code: BQ_MASTER_CACHE_KEYS.currencies,
	trade_group_code: BQ_MASTER_CACHE_KEYS.tradeGroups,
	agent_code: BQ_MASTER_CACHE_KEYS.agents,
	transporter_code: BQ_MASTER_CACHE_KEYS.transporters,
	merchandiser_code: BQ_MASTER_CACHE_KEYS.merchandisers,
	channel: BQ_MASTER_CACHE_KEYS.channels,
	barcode: BQ_MASTER_CACHE_KEYS.itemsPo,
	item_code: BQ_MASTER_CACHE_KEYS.itemsPo,
};

/** SO header / line column.key → GlobalContext cache key (owner + destination share sites) */
export const soMasterCacheKeyByColumn = {
	owner_site_code: BQ_MASTER_CACHE_KEYS.sites,
	destination_site_code: BQ_MASTER_CACHE_KEYS.sites,
	item_code: BQ_MASTER_CACHE_KEYS.items,
};

/** In-flight default fetches by cache key — prevents duplicate master calls on mount. */
const inflightMasterFetches = new Map();

export const fetchMasterDefaultOnce = (cacheKey, fetcher) => {
	if (!cacheKey || typeof fetcher !== "function") return Promise.resolve(null);
	if (inflightMasterFetches.has(cacheKey)) return inflightMasterFetches.get(cacheKey);
	const pending = Promise.resolve()
		.then(fetcher)
		.finally(() => {
			inflightMasterFetches.delete(cacheKey);
		});
	inflightMasterFetches.set(cacheKey, pending);
	return pending;
};
